module.exports = __webpack_public_path__ + "static/img/PC-5.a051c39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/PC-5.png
// module id = FtcC
// module chunks = 0